import React, { ReactNode } from 'react';
import Fallback from 'router/Fallback';
import { useKeycloak } from '../auth/KeycloakProvider';

interface IPrivateRouteProps {
  children: ReactNode;
}

const PrivateRoute = ({ children }: IPrivateRouteProps) => {
  const { keycloak, initialized } = useKeycloak();

  if (!initialized) {
    return <Fallback />;
  }

  if (!keycloak.authenticated) {
    return <Fallback />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
